export const deviceTrackingStyles = {
    trackingActive: {
        color: "#43a047",
        fontSize: 26,
    },

    trackingWarning: {
        color: "#f9a825",
        fontSize: 24,
    },

    trackingInUse: {
        color: "#8e24aa",
        fontSize: 24,
    },

    trackingConfigured: {
        color: "#2468c0",
        fontSize: 24,
    },

    trackingNoSignal: {
        color: "#be1818",
        fontSize: 24,
    },

    trackingDisabled: {
        color: "#d0d0d0",
        fontSize: 26,
    },

    trackingWrapper: {
        position: "relative",
        width: 46,
        height: 46,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
    },

    trackingWarningBadge: {
        position: "absolute",
        top: 4,
        right: 4,
        fontSize: 16,
        color: "#F9AB2D",
        zIndex: 2,
    },

    trackingErrorBadge: {
        position: "absolute",
        top: 4,
        right: 4,
        fontSize: 16,
        color: "#be1818",
        zIndex: 2,
    },

    trackingStatusCard: {
        width: "100%",
        borderRadius: 16,
        border: "1px solid #e4e7ea",
        backgroundColor: "#fff",
        padding: "20px 28px",
        boxSizing: "border-box",
    },

    trackingStatusBody: {
        display: "flex",
        alignItems: "center",
        gap: 18,

        "@media (max-width:600px)": {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 16,
        },
    },

    trackingStatusIconContainer: {
        "& $trackingWrapper": {
            width: 64,
            height: 64,
            minWidth: 64,
        },

        "& $trackingActive": {
            fontSize: 32,
        },

        "& $trackingWarning": {
            fontSize: 31,
        },

        "& $trackingInUse": {
            fontSize: 31,
        },

        "& $trackingConfigured": {
            fontSize: 31,
        },

        "& $trackingNoSignal": {
            fontSize: 31,
        },

        "& $trackingDisabled": {
            fontSize: 31,
        },

        "& $trackingWarningBadge": {
            top: 9,
            right: 9,
            fontSize: 18,
        },

        "& $trackingErrorBadge": {
            top: 9,
            right: 9,
            fontSize: 18,
        },

        "@media (max-width:600px)": {
            "& $trackingWrapper": {
                width: 54,
                height: 54,
                minWidth: 54,
            },

            "& $trackingActive": {
                fontSize: 28,
            },

            "& $trackingWarning": {
                fontSize: 27,
            },

            "& $trackingInUse": {
                fontSize: 27,
            },

            "& $trackingConfigured": {
                fontSize: 27,
            },

            "& $trackingNoSignal": {
                fontSize: 27,
            },

            "& $trackingDisabled": {
                fontSize: 27,
            },

            "& $trackingWarningBadge": {
                top: 10,
                right: 11,
                fontSize: 12,
            },

            "& $trackingErrorBadge": {
                top: 10,
                right: 11,
                fontSize: 12,
            },
        },
    },

    trackingStatusInfo: {
        flex: 1,
        minWidth: 0,
    },

    trackingStatusTitle: {
        fontSize: 20,
        fontWeight: 600,
        lineHeight: 1.25,

        "@media (max-width:600px)": {
            fontSize: 17,
        },
    },

    trackingStatusDate: {
        marginTop: 8,
        color: "#5f6872",
        fontSize: 15,

        "@media (max-width:600px)": {
            fontSize: 13,
        },
    },

    trackingStatusActions: {
        minWidth: 190,
        paddingLeft: 28,
        borderLeft: "1px solid #d9dde2",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 10,

        "@media (max-width:600px)": {
            width: "100%",
            minWidth: "auto",
            paddingLeft: 0,
            borderLeft: "none",
            alignItems: "stretch",
        },
    },

    trackingMapButton: {
        minWidth: 140,
        height: 42,
        borderRadius: 6,
        fontWeight: 600,
        textTransform: "none",
    },

    trackingRefreshButton: {
        color: "#7d8a96",
        fontWeight: 600,
        textTransform: "none",
        fontSize: 13,
        minHeight: 30,
        padding: "4px 12px",

        "&:hover": {
            backgroundColor: "#f5f7f8",
        },
    },
};